export { default } from './store-widget.component';
